import { definePagePlugin } from '../types';

export default definePagePlugin(
  {
    pluginId: 'internal:w-plugin-openai',
    name: '无极AI插件',
    description: '启用后，可通过 w.ai 发起 AI 模型调用。用法与 <a href="https://www.npmjs.com/package/openai/v/4.97.0" target="_blank">[openai@4.97.0]</a> 一致',
    icon: 'http://formal-75535.gzc.vod.tencent-cloud.com/default-logo.png',
    propsSchema: {
      type: 'object',
      fields: [],
    },
  },
  () => import('./plugin').then(x => x.default),
);
